export enum EvaluationCreationErrorsEnum {
  none = 0,
  name = 1,
  options = 2,
}
